import { getSelectShiftTypeFontSize } from "@/utils/fontSizeUtils";

function SelectShiftTypeButton({
  isChecked,
  setSelectedShiftType,
  shift_id,
  name,
  color,
  isExistWanted,
  disabled,
}: {
  isChecked: boolean;
  setSelectedShiftType: React.Dispatch<React.SetStateAction<string>>;
  shift_id: string;
  name: string;
  color: string;
  isExistWanted: boolean;
  disabled?: boolean;
}) {
  // submittedStatus === "closed" 이면 눌리지 않도록 / 비활성화 적용
  return (
    // <div className={`w_myWanted__selectShiftItem ${disabled ? "!cursor-default" : ""}`}>
    <div
      className={`w_myWanted__selectShiftItem ${disabled ? "!cursor-default" : ""} w-[63px]`}
    >
      {!disabled && isExistWanted ? (
        <label
          className={`w_myWanted__selectShiftButton ${isChecked ? "select" : ""}`}
          style={
            {
              "--shiftColor_char": color,
              fontSize: getSelectShiftTypeFontSize(shift_id),
            } as React.CSSProperties
          }
        >
          <input
            type="radio"
            name="manualShift"
            value={shift_id}
            checked={isChecked}
            onChange={() => {
              !disabled && setSelectedShiftType(shift_id);
            }}
          />
          <span className="truncate">{shift_id}</span>
        </label>
      ) : (
        <div
          className={`w_myWanted__selectShiftButton ${disabled ? "!cursor-default" : ""}`}
        >
          {shift_id}
        </div>
      )}
      <div className="mt-[10px] text-[14px] font-pretendard text-center font-light text-text-sub break-words">
        <span className="truncate">{name}</span>
      </div>
    </div>
  );
}

export default SelectShiftTypeButton;
